import { useState } from "react"
import PropTypes from "prop-types"
import { Button } from "@mui/material"
import { get } from "lodash"
import InlineSelector from "components/inline-selector"
import { stringifyState } from "helpers/queryString"
import { DATE } from "helpers/shapes"
import { formatLongDate } from "helpers/formatters/dates"
import withNavigate from "hocs/withNavigate"
import CompositeList from "./components/list"
import { getSecuritiesFinderFilterAndSort } from "./helpers"
import { COMPOSITE } from "./shapes"

import "./style.scss"

const BUTTONS = [
  { value: "positive", display: "positive" },
  { value: "negative", display: "negative" },
]

function TopComposites({ account, modelId, date, exposedComposites, factorId, openCompositeSecurity, navigate, missingDataFiles }) {
  const [selectedType, setSelectedType] = useState("positive")
  const composites = get(exposedComposites, selectedType, [])

  function handleRefineSearch() {
    const securitiesState = {
      date,
      ...getSecuritiesFinderFilterAndSort(factorId, selectedType, missingDataFiles),
      additionalColumns: { exposure: [factorId] },
    }
    navigate(`/${account}/home/market/securities?${stringifyState(securitiesState)}`)
  }

  return <div className="modules_factor-profile-composites">
    <div className="composite-header">
      <h5 className="title">{`Most Exposed Indexes & ETFs as of ${formatLongDate(date)}`}</h5>
      <Button color="primary" variant="outlined" onClick={handleRefineSearch}>Refine Search</Button>
    </div>
    <InlineSelector options={BUTTONS} selectedValue={selectedType} onSelect={setSelectedType} />
    <CompositeList {...{ account, modelId, date, composites, type: selectedType, openCompositeSecurity }} />
  </div>
}

TopComposites.propTypes = {
  account: PropTypes.string.isRequired,
  portfolioId: PropTypes.string,
  factorId: PropTypes.string.isRequired,
  exposedComposites: PropTypes.shape({
    positive: PropTypes.arrayOf(COMPOSITE),
    negative: PropTypes.arrayOf(COMPOSITE),
  }).isRequired,
  date: DATE.isRequired,
  modelId: PropTypes.string.isRequired,
  openCompositeSecurity: PropTypes.func.isRequired,
  navigate: PropTypes.func.isRequired,
  missingDataFiles: PropTypes.arrayOf(PropTypes.string).isRequired,
}

export default withNavigate(TopComposites)
